"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../../api/webAApi");
var BonusTournamentsSessionsListCtl = /** @class */ (function (_super) {
    __extends(BonusTournamentsSessionsListCtl, _super);
    function BonusTournamentsSessionsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_usr_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_id; });
        _this.dk_usr_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_login; });
        _this.dk_tickets_available = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tickets_available; });
        _this.dk_tickets_buyed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tickets_buyed; });
        _this.dk_tickets_is_unlimited_tickets_buys = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_unlimited_tickets_buys; });
        _this.dk_freespin_count_avail = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_count_avail; });
        _this.dk_freespin_count_played = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_count_played; });
        _this.dk_freespin_win_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_win_amount; });
        _this.dk_is_bot_session = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_bot_session; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTournamentsSessionsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusTournamentsSessionsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    BonusTournamentsSessionsListCtl.prototype.LoadData = function (bonusTournamentId, onDone) {
        var _this = this;
        webAApi_1.ListBonusTournamentSessionsByBonusTournamentIdGet.exec({
            bonus_tournament_id: bonusTournamentId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    usr_player_id: resp.list[i].usr_player_id,
                    usr_player_login: resp.list[i].usr_player_login,
                    tickets_available: resp.list[i].tickets_available,
                    tickets_buyed: resp.list[i].tickets_buyed,
                    is_unlimited_tickets_buys: resp.list[i].is_unlimited_tickets_buys,
                    freespin_count_avail: resp.list[i].freespins_count_available,
                    freespin_count_played: resp.list[i].freespins_count_played,
                    freespin_win_amount: resp.list[i].freespin_win_amount,
                    is_bot_session: resp.list[i].is_bot_session,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsSessionsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusTournamentSession.exec({
            data: {
                bonus_tournament_id: data.bonus_tournament_id,
                usr_player_id: data.usr_player_id,
                tickets_buyed: data.tickets_buyed,
                freespins_count_played: data.freespin_count_played,
                freespin_win_amount: data.freespin_win_amount
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                usr_player_id: data.usr_player_id,
                usr_player_login: resp.usr_player_login,
                tickets_buyed: data.tickets_buyed,
                freespin_count_avail: resp.freespins_count_available,
                tickets_available: resp.tickets_available,
                is_unlimited_tickets_buys: resp.is_unlimited_tickets_buys,
                freespin_count_played: data.freespin_count_played,
                freespin_win_amount: data.freespin_win_amount,
                is_bot_session: resp.is_bot_session,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false)
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsSessionsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusTournamentSession.exec({
                data: {
                    bonus_tournament_session_id: data.key,
                    usr_player_id: data.usr_player_id,
                    tickets_buyed: data.tickets_buyed,
                    freespin_count_played: data.freespin_count_played,
                    freespin_win_amount: data.freespin_win_amount
                }
            }, function (resp) {
                _tmp.usr_player_id = data.usr_player_id;
                _tmp.usr_player_login = resp.usr_player_login;
                _tmp.tickets_available = resp.tickets_available;
                _tmp.tickets_buyed = data.tickets_buyed;
                _tmp.is_unlimited_tickets_buys = resp.is_unlimited_tickets_buys;
                _tmp.freespin_count_avail = resp.freespins_count_available;
                _tmp.freespin_count_played = data.freespin_count_played;
                _tmp.freespin_count_avail = resp.freespins_count_available;
                _tmp.freespin_win_amount = data.freespin_win_amount;
                _tmp.is_bot_session = resp.is_bot_session;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentsSessionsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTournamentsSessionsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusTournamentSession.exec({
                data: {
                    bonus_tournament_session_id: key
                }
            }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTournamentsSessionsListCtl;
}(BaseController_1.BaseController));
exports.BonusTournamentsSessionsListCtl = BonusTournamentsSessionsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ctl/options/BonusTournamentsSessionsLictCtl.ts
// module id = 1022
// module chunks = 0